/**
 * learningZonesUtils.js contains utility functions for adding a new learning tool to a learning zone, and getting the maximum number of learning units that are allowed to be contained in a learning tool.
 */

import axios from "axios";

/**
 * Add a new learning tool and return its id
 * @param {*} learningZoneId - the id of the learning zone to add the new learning tool to.
 * @param {*} toolType - "vocabulary" / "cloze" / "multipleChoice" / "imgToWord"
 * @returns the id of the new learning tool
 */
export const addNewLearningTool = async (learningZoneId, toolType) => {
  const reqUrl = `/learning_tools/create`;

  try {
    const response = await axios.post(reqUrl, {
      toolTypeId: toolType,
      learningZoneId: learningZoneId,
    });

    if (response.status === 200 || response.status === 201) {
      return response.data.learning_tool_id;
    } else {
      console.error("Error: Unexpected response status");
      throw new Error("Failed to create new learning tool.");
    }
  } catch (error) {
    console.error("Error in addNewLearningTool:", error);
    throw new Error("Failed to create new learning tool.");
  }
};

/**
 * Get the maximum number of learning units that can be included in a single learning tool.
 * @returns object with boolean success property, and if true - also a result property with the maximum number of learning units per tool.
 */
export const getMaxUnitsPerTool = async () => {
  const reqUrl = `/learning_tools/max_units_per_tool`;

  try {
    const response = await axios.get(reqUrl);
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error: Unexpected response status");
      throw new Error(
        "Failed to get maximum number of units per learning tool. Unexpected response status."
      );
    }
  } catch (error) {
    console.error("Error in getMaxUnitsPerTool:", error);
    throw new Error(
      `Failed to get maximum number of units per learning tool. Error: ${error.message}`
    );
  }
};
